/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it support accented or non-Latin letters?`)
};

const es_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Admite letras acentuadas o no latinas?`)
};

const de_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden akzentuierte oder nicht-lateinische Buchstaben unterstützt?`)
};

const nl_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondersteunt het geaccentueerde of niet-Latijnse letters?`)
};

const fr_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prend-il en charge les lettres accentuées ou non-latines ?`)
};

const it_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporta lettere accentate o non latine?`)
};

const pt_br2_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele suporta letras acentuadas ou não-latinas?`)
};

const pt_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporta letras acentuadas ou não-latinas?`)
};

const ja_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセント付きまたは非ラテン文字をサポートしていますか?`)
};

const zh_mc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持带重音符号或非拉丁字母吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_faq4_q", locale)
	if (locale === "en") return en_mc_faq4_q(inputs)
	if (locale === "es") return es_mc_faq4_q(inputs)
	if (locale === "de") return de_mc_faq4_q(inputs)
	if (locale === "nl") return nl_mc_faq4_q(inputs)
	if (locale === "fr") return fr_mc_faq4_q(inputs)
	if (locale === "it") return it_mc_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_mc_faq4_q(inputs)
	if (locale === "pt") return pt_mc_faq4_q(inputs)
	if (locale === "ja") return ja_mc_faq4_q(inputs)
	return zh_mc_faq4_q(inputs)
};